import { flagUrl } from "@/lib/api";

// Compute group standings from match predictions
// matches: list of group-stage match docs with home/away codes
// predictions: list of prediction docs with match_id, home_score, away_score
export function computeGroupStandings(group, teamsInGroup, groupMatches, preds) {
  const byTeam = {};
  teamsInGroup.forEach((code) => {
    byTeam[code] = { code, pts: 0, gp: 0, w: 0, d: 0, l: 0, gf: 0, ga: 0 };
  });
  const predByMatch = Object.fromEntries(preds.map((p) => [p.match_id, p]));
  groupMatches.filter((m) => m.group === group).forEach((m) => {
    const p = predByMatch[m.match_id];
    if (!p || p.home_score == null || p.away_score == null) return;
    const t1 = byTeam[m.home], t2 = byTeam[m.away];
    if (!t1 || !t2) return;
    t1.gp++; t2.gp++;
    t1.gf += p.home_score; t1.ga += p.away_score;
    t2.gf += p.away_score; t2.ga += p.home_score;
    if (p.home_score > p.away_score) { t1.pts += 3; t1.w++; t2.l++; }
    else if (p.home_score < p.away_score) { t2.pts += 3; t2.w++; t1.l++; }
    else { t1.pts += 1; t2.pts += 1; t1.d++; t2.d++; }
  });
  const arr = Object.values(byTeam).map((t) => ({ ...t, gd: t.gf - t.ga }));
  arr.sort((a, b) => b.pts - a.pts || b.gd - a.gd || b.gf - a.gf || a.code.localeCompare(b.code));
  return arr;
}

export function TeamRow({ code, name, flag, mini = false }) {
  return (
    <div className="flex items-center gap-2">
      <img src={flagUrl(flag)} alt={code} className={mini ? "w-5 h-3.5 object-cover" : "w-7 h-5 object-cover"} />
      <span className={`font-mono-data ${mini ? "text-xs" : "text-sm"}`}>{code}</span>
      {!mini && <span className="text-xs text-zinc-400 truncate">{name}</span>}
    </div>
  );
}
